import React from 'react'
import SalesReport from '../components/Navbar/SalesReport'
import Navbar from '../components/Navbar/Navbar'

function SalesReportPage() {
    return (
        <>
            <Navbar />
            <SalesReport />
        </>
    )
}

export default SalesReportPage
